import { ApolloQueryResult } from 'apollo-client'
import { HFlow, Icon, TableCell, TableRow, Text, Tooltip, VFlow } from 'bold-ui'
import { ProcedimentoSelectModel } from 'components/form/field/select/ProcedimentoSelectField'
import { IconLabel } from 'components/IconLabel'
import theme from 'config/theme'
import { GrupoExameTableQuery } from 'graphql/types.generated'
import React from 'react'
import { showCodigoProcedimento } from 'view/atendimentos/detail/soap/objetivo/resultados-exames/util-resultadosExames'

import { GrupoExameEditAction } from './GrupoExameEditAction'
import { GrupoExameExcludeAction } from './GrupoExameExcludeAction'
import { GrupoExameRowItem } from './GrupoExameTable'

interface GrupoExameTableRowProps {
  grupoExame: GrupoExameRowItem
  procedimentos: ProcedimentoSelectModel[]
  expandedRow: string
  handleClick(grupoExame: GrupoExameRowItem): any
  refetch(): Promise<ApolloQueryResult<GrupoExameTableQuery>>
}

export function GrupoExameTableRow(props: GrupoExameTableRowProps) {
  const { grupoExame, refetch, procedimentos, expandedRow, handleClick } = props

  const procedureRender = (item: ProcedimentoSelectModel) => {
    return (
      <li key={item.id}>
        {item.ativo ? (
          <VFlow vSpacing={0}>
            <>
              <b>{item.descricao.capitalize()}</b> - {showCodigoProcedimento(item.codigo)}
            </>
            {item.procedimentoReferencia && (
              <>
                <b>{item.procedimentoReferencia.descricao.capitalize()}</b> - {item.procedimentoReferencia.codigo}
              </>
            )}
          </VFlow>
        ) : (
          <VFlow vSpacing={0}>
            <HFlow hSpacing={0.5}>
              <Text style={{ color: theme.pallete.gray.c40 }}>
                {item.descricao.capitalize()} - {showCodigoProcedimento(item.codigo)}
              </Text>
              <Tooltip text='Esse exame está inativo por isso não está disponível no atendimento.'>
                <Icon icon='infoCircleOutline' color={theme.pallete.primary.c40} size={1} />
              </Tooltip>
            </HFlow>
            {item.procedimentoReferencia && (
              <Text style={{ color: theme.pallete.gray.c40 }}>
                {item.procedimentoReferencia.descricao.capitalize()} - {item.procedimentoReferencia.codigo}
              </Text>
            )}
          </VFlow>
        )}
      </li>
    )
  }

  return (
    <React.Fragment key={grupoExame.id}>
      <Tooltip placement='left-start' text={expandedRow === grupoExame.id ? 'Minimizar' : 'Expandir'}>
        <TableRow onClick={handleClick(grupoExame)}>
          <TableCell style={{ paddingLeft: '26px' }}>
            <HFlow alignItems='center' justifyContent='flex-start'>
              <Icon icon={expandedRow === grupoExame.id ? 'angleUp' : 'angleDown'} />
              {grupoExame.nome.capitalize()}
              {grupoExame.hasProcedimentosInativos && (
                <IconLabel icon='infoCircleOutline' text='Contém exames inativos' />
              )}
            </HFlow>
          </TableCell>
          <TableCell>{grupoExame.quantidadeProcedimentos}</TableCell>
          <TableCell>
            <HFlow alignItems='center' justifyContent='flex-end' hSpacing={0}>
              <GrupoExameEditAction grupoExame={grupoExame} />
              <GrupoExameExcludeAction grupoExame={grupoExame} refetch={refetch} />
            </HFlow>
          </TableCell>
        </TableRow>
      </Tooltip>
      {expandedRow && expandedRow === grupoExame.id && procedimentos && (
        <TableRow style={{ backgroundColor: '#f0f0f5' }}>
          <TableCell colSpan={3}>
            <ul style={{ padding: '0 16px', margin: '16px 0', columns: '2' }}>
              {procedimentos.map((item) => procedureRender(item))}
            </ul>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  )
}
